import styled from 'styled-components';

import { MAX_CONTENT_WIDTH, SectionContainer } from '~/src/screens/Landing/layout';
import { media } from '~/src/styles-constants';

export const Container = styled(SectionContainer)`
  display: flex;
  margin-bottom: 100px;
  justify-content: center;
`;

export const Content = styled.div`
  padding: 0 30px;

  ${media.M`
      display: flex;
      justify-content: space-between;
      padding: 0;
  `}
`;

export const InnerContainer = styled.div`
  max-width: ${MAX_CONTENT_WIDTH}px;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Title = styled.h2`
  padding-top: 10px;
  text-align: center;

  color: ${({ theme }) => theme.palette.common.TEXTS};
  font-size: 30px;
  font-weight: 700;
  font-family: ${({ theme }) => theme.fonts.secondary};
  line-height: normal;
`;
